module.exports = __webpack_public_path__ + "static/media/my-family-campaign-banner-desktop.9c048d54.jpg";